// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","nav":"Header_nav__Zdv98","logo-wrapper":"Header_logo-wrapper__TXF2t","logo":"Header_logo__3Cuqg"};